import { Component, forwardRef } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { UserActionFeatureSystemsComponent } from '../userAction-featureSystem/userAction-featureSystem.component';
import { FeatureToBeRenamed } from '../../../../Model/Catalog/FeatureModels/FeatureToBeRenamedModel';
import { ValidFeatureSystem } from '../../../../Model/ValidFeatureSystem';
import { ValidFeatureService } from '../../../../Services/validFeature.service';
import { TranslateService } from '@ngx-translate/core';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { UserActionBaseComponent } from '../userAction-base.component';
import { Macro } from 'app/Model/ui/Macro';

@Component({
    selector: 'userAction-renameFeatures',
    templateUrl: 'userAction-renameFeatures.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionRenameFeaturesComponent) }
    ],
    standalone: false
})
export class UserActionRenameFeaturesComponent extends UserActionFeatureSystemsComponent {
  featuresGridDataSource: Array<FeatureToBeRenamed> = [];
  selectedFeatureSystem: ValidFeatureSystem;
  featuresLoading = false;

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    validFeatureService: ValidFeatureService
  ) {
    super(loginService, macroService, catalogService, validFeatureService);
  }

  onFeatureSystemChanged(e) {
    this.featuresGridDataSource = [];
    if (this.selectedFeatureSystem) {
      this.featuresLoading = true;     
      this.loadFeatures(this.selectedFeatureSystem).then((features) => {
        for (let feature of features) {          
          this.featuresGridDataSource.push(new FeatureToBeRenamed(feature, '', ''));
        }
        this.featuresLoading = false;
      });
    }
  }

  public async canStartMacro() : Promise<boolean>{
    if (this.featuresGridDataSource.length == 0) {     
      return false;
    }

    return true
  }

  createUserAction(): StartAction {
    let userAction = new StartAction();
    userAction.catalogId = this.catalogService.catalog.id;
    userAction.customerId = this.loginService.currentUser.customerId;
    userAction.actionId = `RenameFeatures(${this.createParameterStringAsJsonString()})`;
    return userAction;
  }

  createParameterStringAsJsonString(): string {
    let parameterJsonString = JSON.stringify({
      featureSystemName: this.selectedFeatureSystem.name,
      featuresToBeRenamed: this.featuresGridDataSource
    });
    return parameterJsonString;
  }

  parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.selectedFeatureSystem.name = parsed.featureSystemName;
      this.featuresGridDataSource = parsed.featuresToBeRenamed;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }

  public getActionId(macro: Macro): string {
    return `RenameFeatures(${this.createParameterStringAsJsonString()})`;
  }
}
